<app-breadcrumb
  *ngIf="!mod"
  [master]="'Dobry Agent'"
  [parentName]="'Autorzy'"
  [name]="isEditMode ? 'Edytuj' : 'Dodaj'"
></app-breadcrumb>

<div class="authors-add-container" fxLayout="column" fxLayoutGap="15px">

  <div *ngIf="loading" class="da-author-form-loader">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <form
    *ngIf="!loading"
    #authorForm="ngForm"
    class="da-author-form"
    (ngSubmit)="save(authorForm)"
    fxLayout="column"
    fxFlex="100"
    fxFlex.lt-md="100"
    fxLayoutGap="15px"
  >
    <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">

      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="saving"
      >
        <mat-icon>save</mat-icon>
        <span>{{ saving ? ' Zapisywanie...' : ' Zapisz' }}</span>
      </button>

      <button
        *ngIf="!isEditMode && !mod"
        mat-raised-button
        color="accent"
        type="button"
        (click)="save(authorForm, true)"
        [disabled]="saving"
      >
        <mat-icon>save</mat-icon>
        <span> Zapisz i dodaj kolejnego</span>
      </button>

      <button
        mat-stroked-button
        type="button"
        (click)="cancel()"
        [disabled]="saving"
        color="warn"
      >
        <mat-icon> cancel </mat-icon>
        <span>{{ mod ? ' Zamknij' : ' Anuluj' }}</span>
      </button>

    </div>
    <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
      <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card fxLayout="column">
          <app-section-header
            title="Użytkownik ASF24"
            [description]="isEditMode ? 'Powiązanie autora z użytkownikiem ASF24.' : 'Wybór użytkownika ASF24 jest wymagany. Dane autora zostaną uzupełnione na podstawie wybranego użytkownika.'"
          ></app-section-header>

          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
            <mat-form-field fxFlex="50">
              <mat-label>Imię</mat-label>

              <input
                matInput
                name="firstName"
                required
                maxlength="100"
                placeholder="Np. Jan"
                [(ngModel)]="model.firstName"
                #firstName="ngModel"
                (ngModelChange)="clearBackendError(authorForm, 'firstName')"
              >

              <mat-error *ngIf="firstName.errors?.required && firstName.touched">
                Imię jest wymagane.
              </mat-error>

              <mat-error *ngIf="firstName.errors?.backend && firstName.touched">
                {{ firstName.errors.backend }}
              </mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50">
              <mat-label>Nazwisko</mat-label>

              <input
                matInput
                name="lastName"
                required
                maxlength="100"
                placeholder="Np. Kowalski"
                [(ngModel)]="model.lastName"
                #lastName="ngModel"
                (ngModelChange)="clearBackendError(authorForm, 'lastName')"
              >

              <mat-error *ngIf="lastName.errors?.required && lastName.touched">
                Nazwisko jest wymagane.
              </mat-error>

              <mat-error *ngIf="lastName.errors?.backend && lastName.touched">
                {{ lastName.errors.backend }}
              </mat-error>
            </mat-form-field>
          </div>

          <div
            fxFlex="100"
            [formGroup]="authorReactiveForm"
            fxLayout="column"
            fxLayoutGap="8px"
          >
            <label class="editor-label">Opis</label>

            <angular-editor
              formControlName="description"
              [config]="editorConfig"
              (ngModelChange)="clearDescriptionBackendError()"
            ></angular-editor>

            <mat-error *ngIf="authorReactiveForm.get('description')?.errors?.required && authorReactiveForm.get('description')?.touched">
              Opis jest wymagany.
            </mat-error>

            <mat-error *ngIf="authorReactiveForm.get('description')?.errors?.backend && authorReactiveForm.get('description')?.touched">
              {{ authorReactiveForm.get('description')?.errors?.backend }}
            </mat-error>
          </div>

          <div fxLayout="column" fxLayoutGap="8px">
            <label class="editor-label">Zdjęcie autora</label>



            <div *ngIf="selectedImageFileName" class="selected-file-name">
              Wybrany plik po kadrowaniu: {{ selectedImageFileName }}
            </div>

            <div *ngIf="selectedImagePreview" class="author-current-image">
              <img [src]="selectedImagePreview" [alt]="model.altImage || 'Zdjęcie autora'">
            </div>

            <div *ngIf="isEditMode && model.imagePath && !selectedImagePreview" class="author-current-image">
              <img [src]="model.imagePath" [alt]="model.altImage || 'Zdjęcie autora'">
            </div>
            <div
              fxLayout="row"
              fxLayoutGap="15px"
              fxLayoutAlign="start center"
            >
              <input
                #imageInput
                type="file"
                accept="image/*"
                hidden
                (change)="onImageSelected($event)"
              >

              <button
                mat-stroked-button
                color="primary"
                type="button"
                (click)="imageInput.click()"
                [disabled]="saving || deletingImage"
              >
                <mat-icon>upload</mat-icon>

                <span>
      {{
                    model.imagePath || selectedImageFile
                      ? ' Zmień zdjęcie'
                      : ' Wybierz zdjęcie'
                  }}
    </span>
              </button>

              <button
                *ngIf="selectedImageFile"
                mat-stroked-button
                color="warn"
                type="button"
                (click)="clearSelectedImage(imageInput)"
                [disabled]="saving || deletingImage"
              >
                <mat-icon>close</mat-icon>
                <span> Usuń wybrane</span>
              </button>

              <button
                *ngIf="
      isEditMode
      && model.imagePath
      && !selectedImageFile
    "
                mat-stroked-button
                color="warn"
                type="button"
                (click)="deleteCurrentImage()"
                [disabled]="saving || deletingImage"
              >
                <mat-icon>
                  {{ deletingImage ? 'hourglass_empty' : 'delete' }}
                </mat-icon>

                <span>
      {{
                    deletingImage
                      ? ' Usuwanie...'
                      : ' Usuń zdjęcie'
                  }}
    </span>
              </button>
            </div>
          </div>
          <mat-form-field fxFlex="100" style="margin-top: 15px">
            <mat-label>Alt obrazka</mat-label>
            <input
              matInput
              name="altImage"
              [required]="hasAuthorImage"
              maxlength="255"
              placeholder="Np. Jan Kowalski – doradca ubezpieczeniowy"
              [(ngModel)]="model.altImage"
              #altImage="ngModel"
              (ngModelChange)="clearBackendError(authorForm, 'altImage')"
            >

            <mat-error *ngIf="altImage.errors?.required && altImage.touched">
              Alt obrazka jest wymagany.
            </mat-error>
            <mat-error
              *ngIf="altImage.errors?.required && altImage.touched"
            >
              Podaj tekst alternatywny dla zdjęcia autora.
            </mat-error>

            <mat-error *ngIf="altImage.errors?.backend && altImage.touched">
              {{ altImage.errors.backend }}
            </mat-error>
          </mat-form-field>
          <mat-slide-toggle
            color="accent"
            name="active"
            [(ngModel)]="model.active"
          >
            Aktywny
          </mat-slide-toggle>
        </mat-card>
      </div>
      <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card fxLayout="column">
          <app-section-header
            title="Użytkownik ASF24"
            [description]=" isEditMode ? 'Zmień lub odłącz powiązane konto użytkownika w systemie ASF24.' : 'Powiąż autora z kontem użytkownika w systemie ASF24.'"
          ></app-section-header>
          <app-dict-users
            fxFlex="100"
            label="Użytkownik"
            [multiple]="false"
            [control]="getUserControl()"
            (selectedUser)="selectedUser($event)"
          >
          </app-dict-users>
          <mat-error *ngIf="!isEditMode && asfUserControl.hasError('required') && asfUserControl.touched">
            Wybierz użytkownika ASF24.
          </mat-error>

          <div *ngIf="selectedAsfUser || userObject || partnerObject || ofwcaObject" fxLayout="column" fxFlex="100" fxLayoutGap="15px">

            <app-detail
              *ngIf="selectedAsfUser"
              header="Wybrany użytkownik"
              [value]="(selectedAsfUser.firstName || '') + ' ' + (selectedAsfUser.lastName || '')"
            ></app-detail>

            <div fxLayout="row" fxLayout.lt-md="column" fxFlex="100" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail
                  *ngIf="selectedAsfUser?.email"
                  header="E-mail"
                  [value]="selectedAsfUser.email"
                ></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail
                  *ngIf="selectedAsfUser?.phone"
                  header="Telefon"
                  [value]="selectedAsfUser.phone"
                ></app-detail>
              </div>
            </div>

            <ng-container *ngIf="userObject">
              <app-detail header="Użytkownik ASF24">
                <a
                  class="default-link"
                  [routerLink]="['/uzytkownicy/szczegoly', userObject.uuid]"
                >
                  {{ userObject.firstName }} {{ userObject.lastName }}
                </a>
              </app-detail>
            </ng-container>

            <ng-container *ngIf="partnerObject">
              <app-detail header="Partner">
                <a
                  class="default-link"
                  [routerLink]="['/partnerzy/szczegoly', partnerObject.uuid]"
                >
                  {{ partnerObject.shortName }}
                </a>
              </app-detail>
            </ng-container>

            <ng-container *ngIf="ofwcaObject">
              <app-detail header="OFWCA">
                <a
                  class="default-link"
                  [routerLink]="['/ofwca/szczegoly', ofwcaObject.uuid]"
                >
                  {{ ofwcaObject.fullName }}
                </a>
              </app-detail>
            </ng-container>

            <button
              mat-raised-button
              color="warn"
              type="button"
              (click)="clearSelectedAsfUser()"
              [disabled]="saving"
            >
              <mat-icon>close</mat-icon>
              <span> Odłącz użytkownika ASF24</span>
            </button>
          </div>
        </mat-card>

      </div>
    </div>

  </form>
</div>
